import { useMutation } from "react-query";
import { preCreatePolicyAgents } from "./policy-agents-service";

export const usePreCreatePolicyAgents = (config?: any) => {
  return useMutation((data: any) => preCreatePolicyAgents(data), config);
};
